'use client';
import { QueryClientProvider as TanstackQueryClientProvider } from '@tanstack/react-query';
import type { PropsWithChildren, ReactNode } from 'react';

import { getQueryClient } from '../lib/getQueryClient.js';

type QueryClientProviderProps = PropsWithChildren;

/**
 * QueryClientProvider component that provides a Tanstack QueryClient to the children.
 * Should be rendered close to the root of the component tree.
 *
 * @param root0 Component props object
 * @param root0.children Component JSX children
 * @returns QueryClientProvider component
 */
export function QueryClientProvider({ children }: QueryClientProviderProps): ReactNode {
  const queryClient = getQueryClient();

  return <TanstackQueryClientProvider client={queryClient}>{children}</TanstackQueryClientProvider>;
}
